import {
  ApiClientError,
  LocationACL,
  UpdateResourceACLV5,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useUpdateResourceACLV5() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    LocationACL[],
    ApiClientError,
    { params: UpdateResourceACLV5 }
  >(
    async ({ params }) => {
      const response = await raydiant.updateResourceACLV5(params);
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
